var React = require('react');

function Hippo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62A96 96 0 0 0 416 64a95 95 0 0 0-32 5.88V56a24 24 0 0 0-24-24h-16a24 24 0 0 0-24 24v49c-34-25.4-78.76-41-128-41C86 64 0 135.64 0 224v240a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V288h192a32 32 0 0 0 32-32v-92c0-34.11-24.79-67.61-58.88-67.8zM448 176a16 16 0 1 1 16-16 16 16 0 0 1-16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M544 288v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16zm-96-144a16 16 0 1 0 16 16 16 16 0 0 0-16-16z","className":"fa-primary","key":2})]);
}

Hippo.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Hippo;

Hippo.default = Hippo;
